import Dinero from 'dinero.js'

const setDineroDefaults = () => {
  // Setup defaults for Dinero library
  Dinero.globalLocale = 'en-AU'
  Dinero.defaultCurrency = 'AUD'
}

export default setDineroDefaults
